
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ILookupService, LookupCriteria, LookupItemViewModel } from "@tylertech/tyler-api-types";

/**
 * ProjectAccountCategoryLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ProjectAccountCategoryLookupService {
    private readonly $apiService = inject(ApiService);
    
    Lookup(pCriteria: LookupCriteria): Promise<LookupItemViewModel[]> {
        return this.$apiService.sendAuth("IProjectAccountCategoryLookupService/Lookup", pCriteria);
    }
}
